import { Controller } from 'stimulus';

/**
 * Inline-edit for snapshot-editable billing sheet cells.
 *
 * Shows read-only text with a pencil icon. Clicking the pencil reveals the
 * input/select and replaces pencil with tick (confirm) / cross (cancel) icons.
 *
 * @target display   - the read-only text wrapper (shown by default)
 * @target editor    - the input/select wrapper (hidden by default)
 * @target field     - the actual input/select element inside editor
 */
export default class extends Controller {
  static targets = ['display', 'editor', 'field'];

  connect() {
    this.originalValue = this.fieldTarget.value;
  }

  edit() {
    this.originalValue = this.fieldTarget.value;
    this.displayTarget.classList.add('d-none');
    this.editorTarget.classList.remove('d-none');
    this.fieldTarget.focus();
  }

  confirm() {
    this.updateDisplayText();
    this.editorTarget.classList.add('d-none');
    this.displayTarget.classList.remove('d-none');

    // Trigger save via the autosave controller on the parent row
    const row = this.element.closest('[data-controller~="billing-autosave"]');
    if (row) {
      const autosave = this.application.getControllerForElementAndIdentifier(
        row,
        'billing-autosave'
      );
      if (autosave) {
        autosave.lastChangedField = this.fieldTarget;
        autosave.saveNow();
      }
    }
  }

  cancel() {
    this.fieldTarget.value = this.originalValue;
    this.editorTarget.classList.add('d-none');
    this.displayTarget.classList.remove('d-none');
  }

  updateDisplayText() {
    const textSpan = this.displayTarget.querySelector(
      '[data-billing-inline-edit-target="text"]'
    );
    if (!textSpan) return;

    if (
      this.fieldTarget.tagName === 'SELECT' &&
      this.fieldTarget.selectedOptions.length
    ) {
      textSpan.textContent = this.fieldTarget.selectedOptions[0].text;
    } else {
      textSpan.textContent = this.fieldTarget.value;
    }
  }
}
